export const DELAY = {
  onSearch: 500,
}
